/**
 * This library does not have automated tests. After editing be sure to manually test:
 * - Moving an existing PolygonPoint
 * - Add a new PolygonPoint
 * - Deleting a PolygonPoint (right click it)
 * - Creating a new polygon
 * - Delete a polygon
 * - Performing all the above actions on the newly created polygon.
 */
window.POLYGON_EDIT_SUBDIVISIONS = {
    options: {
        
    },
    polygons: [],
    promiseHandlers: {},
    areaId: undefined, // Stores the ID of the area we've loaded to be used when creating new subdivisions.
    init: function (options) {
        _.extend(window.POLYGON_EDIT_SUBDIVISIONS.options, options);
        
        L.PM.setOptIn(false); // Workaround for: https://github.com/geoman-io/leaflet-geoman/issues/795

        return (new Promise(function (resolve, reject) {
            window.MAPS.init().then(function () {
                window.POLYGONS.init({
                    map: window.MAPS.map,
                });

                window.MAPS.map.options.pmIgnore = false;
                L.PM.reInitLayer(window.MAPS.map);

                window.POLYGON_EDIT_SUBDIVISIONS._bindToMapEvents();

                window.MAPS.map.pm.addControls({
                    position: 'topleft',
                    drawCircle: false,
                    drawMarker: false,
                    drawCircleMarker: false,
                    drawPolyline: false,
                    drawRectangle: false,
                    cutPolygon: false,
                });

                resolve();
            });
        })).catch(error => console.error(error));
    },
    _bindToMapEvents() {
        window.MAPS.map.on('pm:drawstart', window.POLYGON_EDIT_SUBDIVISIONS._pmDrawStart);
    },
    /**
     * Triggered when we start creating a polygon, before adding any waypoints.
     * We'll save it after we've added ,
     * @param e 
     */
    _pmDrawStart: function (e) {
        var polygonLayer = e.workingLayer;
        polygonLayer.inoriaModel = {
            name: prompt('What would you like to call this Subdivision?')
        }
        console.log(`${polygonLayer.inoriaModel.name} pm:drawstart triggered`);
        window.POLYGON_EDIT_SUBDIVISIONS._initSubdivisionPolygonLayer(polygonLayer);
    },
    loadArea: function (id) {
        if (window.POLYGON_EDIT_SUBDIVISIONS.areaId !== undefined) {
            console.error(
                'Only one area can be loaded at a time and I have already loaded Area#'
                + window.POLYGON_EDIT_SUBDIVISIONS.areaId
            );
        }
        window.POLYGON_EDIT_SUBDIVISIONS.areaId = id;
        window.POLYGONS.showArea(id).then(function (data) {
            window.POLYGONS.fitBoundsToPolygon(data.control.inoriaModel.id);
        });

        this.getAreaSubdivisions(id).then(function (data) {
            var subdivisions = data.data.results;
            subdivisions.forEach(function (subdivision, index) {
                window.POLYGON_EDIT_SUBDIVISIONS.loadSubdivision(subdivision);
            });
        });
    },
    loadSubdivision: function (subdivision) {
        window.POLYGONS.showSubdivision(subdivision.id).then(function (data) {
            var polygonLayer = data['control'];
            window.POLYGON_EDIT_SUBDIVISIONS._initSubdivisionPolygonLayer(polygonLayer);
        });
    },
    _initSubdivisionPolygonLayer: function (polygonLayer) {
        console.log(`${polygonLayer.inoriaModel.name} initialising polygon`);
        polygonLayer.options.pmIgnore = false;
        L.PM.reInitLayer(polygonLayer);
        window.POLYGON_EDIT_SUBDIVISIONS._bindPolygonTooltip(polygonLayer);
        window.POLYGON_EDIT_SUBDIVISIONS._bindToPolygonEvents(polygonLayer);
    },
    _bindPolygonTooltip: function (polygonLayer) {
        // We cannot add a tooltip with fewer than 3 latlngs
        // because we don't have a center.
        if (polygonLayer.getLatLngs().length < 3) {
            return;
        }
        polygonLayer.bindTooltip(
            polygonLayer.inoriaModel.name,
            {
                permanent: true,
            }
        );
    },
    /**
     * Bind to the Edit event to save polygons when they've been changed. Binds
     * the correct events depending on whether the polygon is saved or not.
     * @param polygonLayer 
     */
    _bindToPolygonEvents: function (polygonLayer) {
        window.POLYGON_EDIT_SUBDIVISIONS._unbindToPolygonEvents(polygonLayer);
        /**
         * Vertex Added is only used on new polygons until they're saved.
         * After that we use pm:edit to catch changes.
         */
        if (!polygonLayer.inoriaModel || !polygonLayer.inoriaModel.id) {
            console.log(`${polygonLayer.inoriaModel.name} binding to new-polygon events`);
            polygonLayer.on('pm:vertexadded', window.POLYGON_EDIT_SUBDIVISIONS._pmVertexAdded);
        } else {
            console.log(`${polygonLayer.inoriaModel.name} binding to existing-polygon events`);
            polygonLayer.on('pm:edit', window.POLYGON_EDIT_SUBDIVISIONS._pmEdit);
            // When drawing new polygons we don't get `pm:edit` but we do vet `pm:vertexadded`
            // so no harm in listening to that too.
            polygonLayer.on('pm:vertexadded', window.POLYGON_EDIT_SUBDIVISIONS._pmEdit);
            polygonLayer.on('remove', window.POLYGON_EDIT_SUBDIVISIONS._polygonLayerRemove);
        }
    },
    /**
     * Remove any event listeners we have. We do this when converting between an unsaved
     * and a saved polygon.
     */
    _unbindToPolygonEvents: function (polygonLayer) {
        console.log(`${polygonLayer.inoriaModel.name} unbinding from polygon events`);
        polygonLayer.off('pm:vertexadded', window.POLYGON_EDIT_SUBDIVISIONS._pmVertexAdded);
        polygonLayer.off('pm:edit', window.POLYGON_EDIT_SUBDIVISIONS._pmEdit);
        polygonLayer.off('pm:vertexadded', window.POLYGON_EDIT_SUBDIVISIONS._pmEdit);
        polygonLayer.off('remove', window.POLYGON_EDIT_SUBDIVISIONS._polygonLayerRemove);
    },
    _polygonLayerRemove: function (e) {
        var polygonLayer = e.target;
        console.log(`${polygonLayer.inoriaModel.name} triggered remove`);
        if (!polygonLayer.inoriaModel || !polygonLayer.inoriaModel.id) {
            // No need to delete from the server if we've not saved it yet.
            return true;
        }

        if (polygonLayer.inoriaModel && polygonLayer.inoriaModel.type && polygonLayer.inoriaModel.type !== 'subdivision') {
            console.log('Refuding to delete a non-subdivision');
            return false;
        }

        if (polygonLayer._pmTempLayer) {
            // When we finish a polygon Geoman removed it and re-adds a new, completed
            // polygon. If that's the reason this Remove has been triggered - ignore it.
            return true;
        }

        return axios.delete(
            route('crud.rest.polygon', { id: polygonLayer.inoriaModel.id }),
        ).catch(error => console.error(error));
    },
    /**
     * Triggered whern an existing polygon (e.g. one saved into the database and
     * which has an ID) is modified.
     */
    _pmEdit: function (e) {
        var polygonLayer = e.layer || e.workingLayer; // .layer is for saved polygons e.workingLayer is for newly drawn ones.
        console.log(`${polygonLayer.inoriaModel.name} triggered pm:edit (or pm:vertexadded)`);
        if (!polygonLayer.inoriaModel || !polygonLayer.inoriaModel.id) {
            console.error('Ignoring pm:edit on polygon because it has not been saved. This should not happen and suggests the wrong events have been bound.');
            return;
        }
        window.POLYGON_EDIT_SUBDIVISIONS._makePolygonLookUnsaved(polygonLayer);

        // If we have a reference to a promise, that means the last request hasn't happened yet.
        // Add another "then" to that request to re-trigger _pmEdit
        var debounceKey = `save_polygon_points_debounce_${polygonLayer.inoriaModel.id}`;
        if (window.POLYGON_EDIT_SUBDIVISIONS.promiseHandlers[debounceKey]) {
            // We only ever need one of these `thens` because it just triggers a new save at the current/latest
            // state of the polygon (e.g. if the user clicks fast and adds another point before this extra `then`
            // is finished, that latest point will still be saved since the latest version of the polygon at the
            // time it gets called is used.
            if (window.POLYGON_EDIT_SUBDIVISIONS.promiseHandlers[debounceKey].hasPendingSaveThen) {
                // We already have an extra "then" queued up to re-save the polygon. No need to add another.
                return;
            }
            window.POLYGON_EDIT_SUBDIVISIONS.promiseHandlers[debounceKey].hasPendingSaveThen = true;
            window.POLYGON_EDIT_SUBDIVISIONS.promiseHandlers[debounceKey].then(function () {
                window.POLYGON_EDIT_SUBDIVISIONS._makePolygonLookUnsaved(polygonLayer);
                window.POLYGON_EDIT_SUBDIVISIONS._pmEdit(e);
                delete window.POLYGON_EDIT_SUBDIVISIONS.promiseHandlers[debounceKey].hasPendingSaveThen;
            });
            return;
        }
        window.POLYGON_EDIT_SUBDIVISIONS.promiseHandlers[debounceKey]
            = window.POLYGON_EDIT_SUBDIVISIONS._savePolygonPoints(polygonLayer)
                .then(function () {
                    console.log(`${polygonLayer.inoriaModel.name} save finished`);
                    window.POLYGON_EDIT_SUBDIVISIONS._makePolygonLookSaved(polygonLayer);
                    delete window.POLYGON_EDIT_SUBDIVISIONS.promiseHandlers[debounceKey];
                }).catch(error => console.error(error));
    },
    _savePolygonPoints: function (polygonLayer) {
        console.log(`${polygonLayer.inoriaModel.name} saving Polygon Points`);
        // Collect up the LatLngs in the format (and with the ordering) we need
        // to save them as PolygonPoints
        var latLngOrder = 0;
        // For some reason existing polygons return an array of LatLng arrays
        // while new ones just return the polygons directly. Detect if we've
        // got an extra layer (and remove it) by checking for the presence of 
        // .lat
        var polygonLatLngs = polygonLayer.getLatLngs();
        if ( ! polygonLatLngs[0].lat) {
            polygonLatLngs = polygonLatLngs[0];
        }
        var latLngs = polygonLatLngs.map(function (latLng) {
            return {
                lat: latLng.lat,
                lng: latLng.lng,
                order: latLngOrder++,
            };
        });

        return axios.post(
            route('polygon-waypoints.set-by-polygon', { polygon: polygonLayer.inoriaModel.id }),
            {
                polygon_points: latLngs,
            }
        ).catch(error => console.error(error));
    },
    /**
     * Triggered when a unsaved polygon (e.g. one which has just started being drawn
     * has a polygon point added). This method doesn't do much until there are more than
     * 3 waypoints at which case it converts the PolygonLayer into a "saved" one (e.g. so)
     * if the user refreshes the page it should all be there.
     */
    _pmVertexAdded: function (e) {
        var polygonLayer = e.workingLayer;
        console.log(`${polygonLayer.inoriaModel.name} triggered pm:vertexadded`);
        window.POLYGON_EDIT_SUBDIVISIONS._makePolygonLookUnsaved(polygonLayer);

        // Sanity check - abort if this is not a new polygon.
        if (polygonLayer.inoriaModel && polygonLayer.inoriaModel.id) {
            console.log('Ignoring pm:vertexadded on polygon because it has been saved');
            return;
        }
        // If we don't have 3 LatLngs, we can't yet save, but that's OK.
        if (polygonLayer.getLatLngs().length < 3) {
            return;
        }

        // Remove any events while we transition from "not-saved" to "saved"
        // to avoid double-saving when the 3rd and 4th waypoint are added
        // in quick succession.
        window.POLYGON_EDIT_SUBDIVISIONS._unbindToPolygonEvents(polygonLayer);

        // If we have more than 3 latlngs, save the subdivision and reinit
        // it as a saved one.
        window.POLYGON_EDIT_SUBDIVISIONS._createNewSubdivision(polygonLayer)
            .then(function () {
                window.POLYGON_EDIT_SUBDIVISIONS._initSubdivisionPolygonLayer(polygonLayer);
                // Emulate an edit so the waypoints get saved. This will also make it look saved again.

                window.POLYGON_EDIT_SUBDIVISIONS._savePolygonPoints(polygonLayer)
                    .then(function () {
                        window.POLYGON_EDIT_SUBDIVISIONS._makePolygonLookSaved(polygonLayer);
                    }).catch(error => console.error(error));
            });
    },
    /**
     * Called after a polygon has been created and had at least 3 waypoints
     * added. Creates the Polygon in the database then returns a promise which
     * gets used to save the waypoints.
     * 
     * @return Promise
     */
    _createNewSubdivision: function (polygonLayer) {
        console.log(`${polygonLayer.inoriaModel.name} saving as a new polygon`);
        return axios.put(
            route('crud.rest.polygon.put'),
            {
                parent_id: window.POLYGON_EDIT_SUBDIVISIONS.areaId,
                name: polygonLayer.inoriaModel.name,
                type: 'subdivision',
            }
        ).then(function (response) {
            var polygonModel = response.data;
            // Inject the new model into the polygon layer (to match what
            // `window.POLYGONS._drawPolygon()` does when it loads a ready made polygon.
            polygonLayer.inoriaModel = polygonModel;
        }).catch(error => console.error(error));
    },
    _makePolygonLookUnsaved: function (polygonLayer) {
        console.log(`${polygonLayer.inoriaModel.name} is now looking unsaved.`);
        if (!polygonLayer.inoriaOriginalColor) {
            polygonLayer.inoriaOriginalColor = polygonLayer.options.color;
        }
        polygonLayer.setStyle({
            color: '#fc888a',
        });
    },
    _makePolygonLookSaved: function (polygonLayer) {
        if (!polygonLayer.inoriaOriginalColor) {
            console.error('Cannot make polygon look saved, I do not have an original colour for it:');
            console.error(polygonLayer);
            return;
        }
        console.log(`${polygonLayer.inoriaModel.name} is now looking saved.`);
        polygonLayer.setStyle({
            color: polygonLayer.inoriaOriginalColor,
        });
    },
    /**
     * Returns a list of Subdivision objects which belong to the given
     * area ID
     * 
     * @return Promise
     */
    getAreaSubdivisions: function (id) {
        console.log('Getting subdivisions for ' + id);
        return axios.post(
            route('crud.rest.polygon.search'),
            {
                filter: {
                    parent_id: [id]
                }
            }
        ).catch(error => console.error(error));
    },
}
